module.exports = __webpack_public_path__ + "img/header_bg.721f6eda.png";